<div formGroupName="cndt">
    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
        <mat-expansion-panel-header class="mat-panel-header-text">
            <mat-panel-title>検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>供給再開予定日（開始）</mat-label>
                <input matInput [matDatepicker]="start" formControlName="supplyresumptionPlndateStart"
                    autocomplete="off" maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                <mat-datepicker #start></mat-datepicker>
            </mat-form-field>
            <span style="margin-left: 40px">～</span>
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>供給再開予定日（終了）</mat-label>
                <input matInput [matDatepicker]="end" formControlName="supplyresumptionPlndateEnd" autocomplete="off"
                    maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                <mat-datepicker #end></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>会社</mat-label>
                <mat-select formControlName="companycode" autocomplete="off" (selectionChange)="onChangeCompany()">
                    <mat-option *ngFor="let type of companyList" [value]="type.value">{{type.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>地区（供給地点）</mat-label>
                <mat-select formControlName="areaSuppntCode" autocomplete="off">
                    <mat-option *ngFor="let type of areaSuppntList" [value]="type.value">{{type.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div formGroupName="workTntsh">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="outline"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>拠点</mat-label>
                    <mat-select formControlName="baseCode" autocomplete="off" (selectionChange)="onChangeBase()">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor="let type of baseList" [value]="type.value">{{type.viewValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>作業担当者</mat-label>
                    <mat-select formControlName="staffCode" autocomplete="off"
                        (valueChange)="onChangeWorkTntsh($event)">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor="let type of workTntshList"
                            [value]="type.value">{{type.viewValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="submit" mat-raised-button color="primary" class="btn"
                    [disabled]="searchConditionForm.invalid">検索</button>
            </mat-action-row>
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="button" mat-raised-button color="primary" class="btn"
                    (click)="onClickClear()">クリア</button>
            </mat-action-row>
        </div>
    </mat-expansion-panel>
</div>